export const megabytesToBytes = (megabytes) => megabytes * 1024 * 1024;
